<template>
  <div class="image-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <el-collapse-item v-if="isBigScreen" @mousedown.native="collapseMouseDown($event, '1')" title="位置尺寸" name="1">
          <div class="setting-item clearFloat">
            <widthAndSizeAndZindex :options="options" :ids="ids" />
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown($event, '2')" title="外观" name="2">
          <div class="setting-item">
            <div class="content">
              <div class="content-item mb16 verticallyCenter">
                <el-checkbox v-model="showReturnText">显示文字</el-checkbox>
              </div>
              <el-input class="el-input el-input--suffix mb16" placeholder="请输入" v-model="returnTextValue">
              </el-input>
              <slider-and-input class="mb16" :value.sync="iconMargin" title="间距" :sliderMax="100" suffix="px" />
              <slider-and-input
                class="mb16"
                inputWidth="small"
                inputHeight="small"
                :value.sync="iconWidth"
                title="图标大小"
                :sliderMax="100"
                suffix="px"
              />
              <div class="content-item mb16">
                <p class="font14 mb8">文字样式</p>
                <text-setting-update
                  :fontColor.sync="color"
                  :fontFamily.sync="fontFamily"
                  :fontSize.sync="fontSize"
                  :fontWeight.sync="fontWeight"
                />
              </div>
              <div class="content-item mb16">
                <border-radius
                  :borderTypeFlag.sync="borderTypeFlag"
                  :borderRadius.sync="borderRadius"
                  :borderTopLeftRadius.sync="borderTopLeftRadius"
                  :borderTopRightRadius.sync="borderTopRightRadius"
                  :borderBottomRightRadius.sync="borderBottomRightRadius"
                  :borderBottomLeftRadius.sync="borderBottomLeftRadius"
                  :sliderMax="paddingMax"
                />
              </div>
              <cx-background :background.sync="background" imgType="10" class="mt16" />
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown($event, '3')" title="高级" name="3">
          <div class="setting-item clearFloat">
            <cx-check-box :value.sync="hideBackButton">新页面打开时隐藏“返回按钮”</cx-check-box>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex.vue"
import TextSettingComplex from "modules/components/textSettingComplex"
export default {
  name: "button-options-setting",
  components: { widthAndSizeAndZindex, TextSettingComplex },
  props: { options: Object },
  data() {
    return {
      collapseActiveNames: [],
      activeNames: ["1", "2"],
      hoverOpt: [],
      sliderMax: 360,
      paddingMax: 200
    }
  },
  comments: {},
  created() {},
  mounted() {},
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    isBigScreen() {
      if (this.request_prefix == "bigScreen") {
        return true
      } else {
        return false
      }
    },
    activeRect() {
      // this.options();
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    width: {
      get() {
        return this.options.width || 0
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "width", false)
      }
    },
    height: {
      get() {
        return this.options.height || 0
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "height", false)
      }
    },
    left: {
      get() {
        return this.options.left || 0
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "left", false)
      }
    },
    top: {
      get() {
        return this.options.top || 0
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "top", false)
      }
    },
    fontSize: {
      get() {
        return this.options.fontSize || 14
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontSize", false)
      }
    },
    fontWeight: {
      get() {
        return this.options.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontWeight", false)
      }
    },
    lineHeight: {
      get() {
        return this.options.lineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeight", false)
      }
    },
    color: {
      get() {
        return this.options.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "color", false)
      }
    },
    textIsThemeColor: {
      get() {
        return this.options.textIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textIsThemeColor", false)
      }
    },
    bgColor: {
      get() {
        return this.options.bgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColor", false)
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "background", false)
      }
    },
    fontFamily: {
      get() {
        return this.options.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontFamily", false)
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.options.borderTopLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return this.options.borderTopRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.options.borderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.options.borderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    borderRadius: {
      get() {
        return this.options.borderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
          false
        )
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("borderTypeFlag")) {
          if (
            ((this.borderTopLeftRadius === this.borderTopRightRadius) === this.borderBottomLeftRadius) ===
            this.borderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    bgType: {
      get() {
        return this.options.bgType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgType", false)
      }
    },
    opacity: {
      get() {
        return this.options.opacity * 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal / 100, "opacity", false)
      }
    },
    iconPosition: {
      get() {
        return this.options.iconPosition
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconPosition", false)
      }
    },
    iconSrc: {
      get() {
        return this.options.iconSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconSrc", false)
      }
    },
    iconType: {
      get() {
        return this.options.iconType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconType", false)
      }
    },
    iconMargin: {
      get() {
        return this.options.iconMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconMargin", false)
      }
    },

    showReturnText: {
      get() {
        return this.options.showReturnText
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showReturnText", false)
      }
    },
    iconWidth: {
      get() {
        return Number(this.options.iconWidth) || 16
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconWidth", false)
      }
    },
    returnTextValue: {
      get() {
        return this.options.content
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "content", false)
      }
    },
    hideBackButton: {
      get() {
        return this.options.hideBackButton || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hideBackButton", false)
      }
    }
  },
  methods: {
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    changeBorderRadiusType(value, hoverFlag) {
      let propName = hoverFlag ? hoverFlag + "BorderTypeFlag" : "borderTypeFlag"
      if (this[propName] === value) {
        return
      }
      this[propName] = value
      // 暂时只处理默认情况  悬浮情况后面有可能会有改动
      this.borderTopRightRadius = this.borderTopLeftRadius
      this.borderBottomLeftRadius = this.borderTopLeftRadius
      this.borderBottomRightRadius = this.borderTopLeftRadius
    },
    resetBorder(val) {
      this.borderRadius = val
      this.borderTopLeftRadius = val
      this.borderTopRightRadius = val
      this.borderBottomRightRadius = val
      this.borderBottomLeftRadius = val
    }
  }
}
</script>

<style scoped>
.w24 {
  width: 24px;
}
.lightColor444 {
  color: rgba(0, 0, 0, 0.4);
}
.deepColor444 {
  color: rgba(255, 255, 255, 0.4);
}
</style>
